import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IbGiftCardsContributionService } from '@src/app/features/pages/contribution/services/ib-gift-cards-contribution/ib-gift-cards-contribution.service';
import { GiftCardsAppConstants } from '@src/app/shared/constants/ib-gift-cards-constants';

@Component({
    selector: 'ib-gift-cards-contribution-sender-data',
    templateUrl: './ib-gift-cards-contribution-sender-data.component.html',
    standalone: true,
    imports: [CommonModule, TranslateModule, ReactiveFormsModule]
})
export class IbGiftCardsContributionSenderDataComponent {
    @Input() form!: FormGroup;
    nameMinLength: number;
    nameMaxLength: number;
    surnamePattern: string;
    nameFocused: boolean = false;
    emailFocused: boolean = false;
    

    constructor (
        public contributionService: IbGiftCardsContributionService
    ) {
        this.nameMaxLength = GiftCardsAppConstants.MAX_FIELD_LENGTH.MAX_LENGTH_NAME;
        this.nameMinLength = GiftCardsAppConstants.MIN_FIELD_LENGTH.MIN_LENGTH_NAME;
        this.surnamePattern = GiftCardsAppConstants.PATTERNS.CONTRIBUTION_SURNAME_PATTERN;
    }

  
    
}
